export const handleCountryCodes = (phone) => {
    let filteredPhone = phone
    filteredPhone = filteredPhone.replace(/[+-]/g, '')
    if (filteredPhone.length === 11 && filteredPhone.charAt(0) === '1') {
        filteredPhone = filteredPhone.slice(1)
    }

    return filteredPhone
}
